import img1 from '../assets/1739276909146.jpg'
import img2 from '../assets/1739277535479.jpg'
import img3 from '../assets/1739277570791.jpg'
import img4 from '../assets/1739277855275.jpg'
import img5 from '../assets/1739348196569.jpg'
import img6 from '../assets/1739277824887.jpg'

export const images =[
    {
        id: 1,
        image: img1 
    },
    {
        id: 2,
        image: img2 
    },
    {
        id: 3,
        image: img3 
    },
    {
        id: 4,
        image: img4 
    },
]

export const switchImg =[
    {
        id: 1,
        image: img1
    },
    {
        id: 2,
        image: img2
    },
    {
        id: 3,
        image: img3
    },
    {
        id: 4,
        image: img4
    },
    {
        id: 5,
        image: img5
    },
    {
        id: 6,
        image: img6
    },
]